<script setup lang="ts">

import { FiltersBar } from '@shared/ui/filters'
import { BtnPrimary } from '@shared/ui/buttons'
import { AppInput } from '@shared/ui/inputs'
import { AppSelect } from '@shared/ui/selects'

import { useFiltersAssignmentTemplates } from '../../../model/assignments/filters-assignment-templates.hook'

defineOptions({
  name: 'FiltersAssignmentTemplates',
})

const {
  refSearch,
  refType,
  refDisciplineCode,
  refGrade,
  refModuleId,
  refModuleOptions,
  refIsModuleLocked,
  refIsModulesLoading,
  refModulePlaceholder,
  refCanManage,
  refIsLoading,
  refHasFilters,
  typeOptions,
  disciplineOptions,
  gradeSelectOptions,
  openCreateModal,
  submitSearch,
  clearFilters,
} = useFiltersAssignmentTemplates()
</script>

<template>
  <FiltersBar
    class="box-filters-assignment-templates"
    :loading="refIsLoading"
    :clearable="refHasFilters"
    @click:submit="submitSearch"
    @click:clear="clearFilters"
  >
    <template #fields>
      <AppInput
        v-model="refSearch"
        label="Search"
        placeholder="Title"
      />

      <AppSelect
        v-model="refGrade"
        :options="gradeSelectOptions"
        label="Grade"
        placeholder="All grades"
        :disabled="refIsLoading"
        clearable
      />

      <AppSelect
        v-model="refDisciplineCode"
        :options="disciplineOptions"
        label="Discipline"
        placeholder="All disciplines"
        :disabled="refIsLoading"
        clearable
      />

      <AppSelect
        v-model="refModuleId"
        :options="refModuleOptions"
        label="Module"
        :placeholder="refModulePlaceholder"
        :disabled="refIsLoading || refIsModuleLocked || refIsModulesLoading"
        clearable
      />

      <AppSelect
        v-model="refType"
        :options="typeOptions"
        label="Type"
        placeholder="All types"
        :disabled="refIsLoading"
        clearable
      />
    </template>

    <template #end>
      <BtnPrimary
        v-if="refCanManage"
        text="Create template"
        color="emerald"
        element-width="auto"
        :disabled="refIsLoading"
        @click="openCreateModal"
      />
    </template>
  </FiltersBar>
</template>

<style scoped lang="scss" src="./FiltersAssignmentTemplates.scss" />
